import { styled } from '@mui/material/styles';
import { Box, Card } from '@mui/material';

export const ProjectsContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(5, 2), // Reduced padding overall
    position: 'relative',
    backgroundColor: 'rgba(46, 54, 73, 0.6)',
    backdropFilter: 'blur(10px)',
    borderRadius: '16px',
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(10, 4), // Restore larger padding on medium screens and up
    },
}));

export const ProjectCard = styled(Card)(({ theme }) => ({
    position: 'relative',
    height: '250px',
    borderRadius: '12px',
    overflow: 'hidden',
    cursor: 'pointer',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
    },
}));

export const ProjectImage = styled('img')(({ theme }) => ({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.5s ease',
    '&:hover': {
        transform: 'scale(1.05)',
    },
}));

export const ProjectOverlay = styled(Box)(({ theme }) => ({
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    padding: theme.spacing(2),
    background:
        'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 100%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    opacity: 0.9,
    transition: 'opacity 0.3s ease',
    '&:hover': {
        opacity: 1,
    },
}));

export const ModalContent = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '900px',
    maxHeight: '90vh',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '12px',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
    padding: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
}));

export const ModalImage = styled('img')(({ theme }) => ({
    width: '100%',
    height: 'auto',
    maxHeight: '70vh',
    objectFit: 'contain',
    backgroundColor: '#000',
}));

export const ModalNavigation = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
}));
